















































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import OccButton from "@/components/Atoms/OccButton/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TableField",
  components: { OccButton },
  props: {
    tableData: {
      type: Array as PropType<Props["tableData"]>,
      required: true
    },
    size: {
      type: String,
      default: "medium",
      validator: function(value) {
        return ["medium", "large"].includes(value);
      }
    }
  },
  computed: {
    sizeClass: function() {
      return this.size && `table__head--${this.size}`;
    }
  }
});
